import React from 'react'
import PropTypes from 'prop-types'
import Instagram from '@mui/icons-material/Instagram'

const InstagramIcon = ({ height, width, ...more }) => {
	
	return (
		<Instagram
			height={height}
			width={width}
			{...more}
		/>
	)
}

InstagramIcon.propTypes = {
	height: PropTypes.number.isRequired,
	width: PropTypes.number.isRequired
}

export default InstagramIcon
